"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _lodash = _interopRequireDefault(require("lodash"));

var _externalSvg = _interopRequireDefault(require("./external-svg"));

var _css = _interopRequireDefault(require("@styled-system/css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DefaultSVGWrapper = (0, _styledComponents["default"])('div').withConfig({
  displayName: "svg__DefaultSVGWrapper",
  componentId: "ehe4wc-0"
})(["display:flex;svg{", "}"], function (props) {
  return (0, _css["default"])({
    fill: props.fill,
    stroke: props.stroke
  });
});
DefaultSVGWrapper.propTypes = {
  fill: _propTypes["default"].string,
  stroke: _propTypes["default"].string
};
/**
 * The SVG component leverages the webpack config
 * found in index.js that runs svg-react-loader on all svgs in
 * the svg folder (`gf-styled/src/svg`)
 *
 * ## Usage
 * ### For core Icon loaded in UI common, pass the id associated:
 *
 * `<SVG id='<icon file name>' />`
 *
 * `<SVG id='checkmark' />`
 *
 * ### For externally hosted svgs:
 *
 * `<SVG svgAsset={contentfulIconObject} />`
 *
 * `<SVG svgAsset={props.globalFooterLogo} />`
 *
 * ### Dimensions
 * The default width/height is 24px/24px. To change this, pass a string
 * as a prop for either prop value. These are applied directly to SVG.
 *
 * #### Unset
 * To unset a width/height - for example, if you wish to make the width
 * responsive to the height - pass a percentage length value
 *
 * ### Classes
 * The `className` prop is passed to `<svg/>` element directly. It is also
 * used for the wrapper class but with `-wrapper` appended.
 */

var SVG = function SVG(_ref) {
  var _svgAsset$fields, _svgAsset$fields$file;

  var id = _ref.id,
      className = _ref.className,
      onClick = _ref.onClick,
      svgAsset = _ref.svgAsset,
      width = _ref.width,
      height = _ref.height,
      noWidth = _ref.noWidth,
      noHeight = _ref.noHeight,
      fill = _ref.fill,
      stroke = _ref.stroke,
      _ref$SVGWrapper = _ref.SVGWrapper,
      SVGWrapper = _ref$SVGWrapper === void 0 ? DefaultSVGWrapper : _ref$SVGWrapper;
  var svgClassName = (0, _classnames["default"])('icon', id, className, {
    hasClick: onClick
  });
  var wrapperClassName = (0, _classnames["default"])("".concat(className, "-wrapper"));
  var svgWidth = noWidth ? undefined : width;
  var svgHeight = noHeight ? undefined : height;

  if (id) {
    var Icon;

    try {
      Icon = require("../../svg/".concat(id, ".svg"));
    } catch (e) {
      console.error("Icon with ".concat(id, " does not exist."));
      console.error(e);
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
    }

    return /*#__PURE__*/_react["default"].createElement(SVGWrapper, {
      className: wrapperClassName,
      onClick: onClick,
      fill: fill,
      stroke: stroke
    }, /*#__PURE__*/_react["default"].createElement(Icon, {
      width: svgWidth,
      height: svgHeight,
      className: svgClassName
    }));
  }
  /**
   * Supporting this for legacy reasons
   */


  var url = String(svgAsset === null || svgAsset === void 0 ? void 0 : (_svgAsset$fields = svgAsset.fields) === null || _svgAsset$fields === void 0 ? void 0 : (_svgAsset$fields$file = _svgAsset$fields.file) === null || _svgAsset$fields$file === void 0 ? void 0 : _svgAsset$fields$file.url);
  return /*#__PURE__*/_react["default"].createElement(_externalSvg["default"], {
    className: svgClassName,
    Wrapper: SVGWrapper,
    wrapperClass: wrapperClassName,
    onClick: onClick,
    url: url,
    width: svgWidth,
    height: svgHeight
  });
};

SVG.propTypes = {
  id: _propTypes["default"].string,
  svgAsset: _propTypes["default"].shape({
    fields: {
      file: {
        url: _propTypes["default"].string
      }
    }
  }),
  className: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  height: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  noWidth: _propTypes["default"].bool,
  noHeight: _propTypes["default"].bool,
  fill: _propTypes["default"].string,
  stroke: _propTypes["default"].string
};
SVG.defaultProps = {
  id: null,
  svgAsset: null,
  className: 'default',
  onClick: null,
  width: 24,
  height: 24,
  noWidth: false,
  noHeight: false,
  fill: 'magic.base',
  stroke: 'magic.base'
};
var _default = SVG;
exports["default"] = _default;